import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const LINES = [
  "INITIALIZING OCTON AVA CORE...",
  "LOADING HEBBIAN SYNAPSE MATRIX...",
  "CALIBRATING BAYESIAN PROPAGATION GRID...",
  "ESTABLISHING HIPPOCAMPUS \u2194 NEOCORTEX BRIDGE...",
  "MOTHERSHIP ONLINE.",
];

export default function BootSequence({ onComplete }) {
  const [lineIndex, setLineIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (lineIndex < LINES.length) {
      const t = setTimeout(() => setLineIndex((i) => i + 1), 420);
      return () => clearTimeout(t);
    }
    const t2 = setTimeout(() => setVisible(false), 500);
    return () => clearTimeout(t2);
  }, [lineIndex]);

  useEffect(() => {
    if (!visible) {
      const t = setTimeout(onComplete, 500);
      return () => clearTimeout(t);
    }
  }, [visible, onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="boot-sequence-overlay"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] bg-[#030509] flex items-center justify-center"
        >
          <div className="font-mono-data text-[11px] sm:text-sm text-cyan-400 space-y-2 tracking-wider">
            {LINES.slice(0, lineIndex).map((line, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                className={i === LINES.length - 1 ? "text-amber-400 font-semibold" : ""}
              >
                {"> "}{line}
              </motion.p>
            ))}
            {lineIndex < LINES.length && (
              <span className="inline-block w-2 h-3.5 bg-cyan-400 animate-pulse" />
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
